import React, { useState } from 'react';
import styled from 'styled-components';
import { FormHelpLink } from '../styles';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { normalizePhone, prevent } from '../../../utils';
import authClient from '../../../api/authClient';
import { Error } from '../styles';
import { LinkId } from 'packages/smart-home-support/constants';

enum Status {
  loading = 'loading',
  idle = 'idle',
  success = 'success',
  error = 'error',
}

const successColor = '#0B8350';

const s = {
  Wrapper: styled.div`
    position: relative;
  `,
  OverlayWrapper: styled.div<{ visible: boolean }>`
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    transition: opacity 0.2s;
    display: ${(props) => (props.visible ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
  `,
  ResendLink: styled(FormHelpLink)``,
  Check: styled.span<{ size: number }>`
    margin-left: 8px;
    display: inline-block;
    transform: rotate(45deg);
    height: ${(props) => props.size * 0.69}px;
    width: ${(props) => (props.size * 0.69) / 2}px;
    border-bottom: ${(props) => props.size * 0.2}px solid ${successColor};
    border-right: ${(props) => props.size * 0.2}px solid ${successColor};
  `,
  Success: styled.div`
    color: ${successColor};
    font-size: 14px;
    font-weight: bold;
  `,
  Error,
};

const ResendConfirmation: React.FC<{ mdn: string }> = (props) => {
  const [status, setStatus] = useState<Status>(Status.idle);

  const onClick = async () => {
    setStatus(Status.loading);
    try {
      await authClient.resendConfirmationPasswordless(normalizePhone(props.mdn));
      setStatus(Status.success);
    } catch (err) {
      setStatus(Status.error);
    } finally {
      setTimeout(() => setStatus(Status.idle), 2000);
    }
  };

  let overlay = <></>;
  switch (status) {
    case Status.loading:
      overlay = <LoadingSpinner size={35} />;
      break;
    case Status.success:
      overlay = (
        <s.Success>
          Code sent <s.Check size={14} />
        </s.Success>
      );
      break;
    case Status.error:
      overlay = <s.Error>Oh no! Something went wrong.</s.Error>;
      break;
  }

  return (
    <s.Wrapper>
      Didn't receive the code?{' '}
      <s.ResendLink id={LinkId.AuthResendSecretCode} to="" onClick={prevent(onClick)}>
        Resend
      </s.ResendLink>
      <s.OverlayWrapper visible={status !== Status.idle}>{overlay}</s.OverlayWrapper>
    </s.Wrapper>
  );
};

export default ResendConfirmation;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/components/ResendConfirmation.tsx